import { downloadLightIcon } from "assets/icons";
import React, { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { dateMonthFormat, formatText, indFormatPrice } from "utils/commonFun";
import { getDownloadReport } from "../../report/downloadReport";
import Spinners from "loader/Spinners";
import { downloadBill } from "./downloadBill";

const TransactionDetails = ({ modalClose, data, selectedSite }) => {
  // console.log('data TransactionDetails', data)
  const [loader, setLader] = useState(false)
  const isPending = data?.billingStatus == "Payment_Pending"
  return (
    <>
      <div className="transaction_details">
        <div className="has_child">
          <h4>Transaction Details</h4>
          <div className="button_wrap">
            <button disabled={loader} onClick={() => downloadBill(selectedSite, setLader, data?.month, data?.year)} type="button" className="download_button">
              {loader ? <Spinners /> :
                <img src={downloadLightIcon} alt="" />}
            </button>
            <button type="button" onClick={modalClose}>
              <FaTimes />
            </button>
          </div>
        </div>
        {!isPending &&
          <div className="payment_receipt _card">
            <ul>
              <li>
                <span>Transaction ID</span>
                <strong>{data?.transactionId ? `${data?.transactionId}` : ''}</strong>
              </li>
              <li>
                <span>Date</span>
                <strong>{dateMonthFormat(data?.transactionDate)}</strong>
              </li>
              {/* <li>
              <span>Status</span>
              <strong className="tag">
                <FaCheck /> {data?.paymentStatus}
              </strong>
            </li> */}
            </ul>
          </div>}

        <div className="_card bill_detail">
          <Link to={`/bills/electricity-generation/${data?.year}/${data?.month}`} className="electricity">
            <span>Electricity Generation</span>
            {/* <span>{data?.amount ? Number(data?.amount).toLocaleString("en-IN") : '0'}</span> */}
            <span>
              {data?.totalSolarGeneration
                ? Number(Number(data.totalSolarGeneration).toFixed(2)).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : '0.00'}
            </span>
          </Link>
          <ul>
            <li>
              <span>Unit Rate (Tariff)</span> <span>{indFormatPrice(data?.unitRate)}</span>
            </li>
            <li>
              <strong>Electricity Savings</strong>
              <strong>{indFormatPrice(data?.electricitySavings)} </strong>
            </li>
            <li>
              <span>Depreciation Savings</span> <span>{indFormatPrice(data?.depreciationSavings)}</span>
            </li>
            <li>
              <span>Tax Savings</span> <span>{indFormatPrice(data?.taxSavings)}</span>
            </li>
            <li>
              <strong>Volt Share in Tax Savings </strong>
              <strong>{indFormatPrice(data?.voltShare)}</strong>
            </li>
            <li>
              <strong>Total Savings </strong>
              <strong>{indFormatPrice(data?.totalSavings)}</strong>
            </li>
            <li>
              <span>Total Payable </span>
              <span>{indFormatPrice(data?.totalPaymentDue)}</span>
            </li>
            {/* <li>
              <span>GST Payment </span> <span>{indFormatPrice(data?.gstPayment)}</span>
            </li> */}
            <li>
              <strong>Payment to Financier</strong> <strong>{indFormatPrice(data?.paymentToFinancier)}</strong>
            </li>
            <li>
              <strong>Billing for the month</strong> <strong>{indFormatPrice(data?.amount)}</strong>
            </li>
            {!isPending && (
              <>
                <li>
                  <span>Pending Last Month </span>
                  <span>{indFormatPrice(data?.lastMonthDueAmount)}</span>
                </li>
                <li>
                  <strong>Total Outstanding </strong>
                  <strong>{indFormatPrice(data?.totalOutstanding)}</strong>
                </li>
              </>
            )}

            <li>
              <strong>Remark</strong>
              <strong>{formatText(data?.billingRemarks) || "N/A"}</strong>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TransactionDetails;
